import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import { SendIcon } from '@treams/treams-icons';
import { Button, Label, PlainInput } from '@treams/treams-ui';

import { MessageInputBox } from '../../goals/goal-ai/SuggestionsAIChatModal';

export function EngagementReplyInput(props: {
	onSubmit: (reply: string) => void;
	anonymous?: boolean;
}) {
	const { t } = useTranslation();
	const [input, setInput] = useState('');
	const inputEnabled = input.trim().length > 0;

	const onSubmit = useCallback(async () => {
		await props.onSubmit(input);
		setInput('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [input, setInput]);

	return (
		<>
			{props.anonymous && <Label mb={2}>{t('engagement.replies.input.anonymous')}</Label>}
			<Flex alignItems="flex-end" justifyContent="flex-start">
				<MessageInputBox mr={2} flexGrow={1}>
					<PlainInput onChange={setInput} autoFocus value={input} />
				</MessageInputBox>
				<Button
					title={t('engagement.replies.input.submit')}
					icon={<SendIcon />}
					type="primary"
					disabled={!inputEnabled}
					onClick={onSubmit}
					flexShrink={0}
				/>
			</Flex>
		</>
	);
}
